import { useState } from 'react'
import { AxiosError } from 'axios'
import { Configuration, EcommerceApi, EcommerceWarehouseApi, GetOrderWarehouseResponse } from 'generated/api'
import { axiosDefaultConfig } from 'constants/axios'
import Toast from 'components/toast/Toast'

const axiosConfig = new Configuration(axiosDefaultConfig)
const ecommerceWarehouseApi = new EcommerceWarehouseApi(axiosConfig)
const ecommerceApiFp = new EcommerceApi(axiosConfig)

export const useOrderConfirmation = () => {
  const [invoiceNumber, setInvoiceNumber] = useState<string>('')
  const [orderConfirmationDetail, setOrderConfirmationDetail] = useState<GetOrderWarehouseResponse | null>(null)
  const [isDisabledInputFetch, setDisabledInputFetch] = useState<boolean>(false)
  const {toast, toastContainer} = Toast()
  // state of modal, and button order status
  const [isModalOpenUpdateOrderStatus, setModalOpenUpdateOrderStatus] = useState<boolean>(false)
  const [isLoadingUpdateOrderStatus, setLoadingUpdateOrderStatus] = useState(false)

  const searchOrder = async () => {
    if (invoiceNumber.length < 1) return
    else await fetchOrderConfirmationDetail()
  }

  const updateOrderStatus = async () => {
    try {
      setLoadingUpdateOrderStatus(true)
      await ecommerceApiFp.ordersUpdateStatus(
        orderConfirmationDetail?.orderId as string,
        'ADMIN_WEB',
        { status: 'COMPLETED' })
      setOrderConfirmationDetail(null)
      setInvoiceNumber('')
      await toast('Pesanan berhasil diselesaikan', 'success')
    } catch (e) {
      const error = e as AxiosError
      const responseStatus = error.response?.status
      let errorMessage = '';
      if (responseStatus === 401) {
        errorMessage = 'Mohon maaf, Anda tidak diizinkan untuk mengakses fitur ini.'
      } else errorMessage = 'terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi.'
      await toast(errorMessage, 'danger')
    } finally {
      setLoadingUpdateOrderStatus(false)
      setModalOpenUpdateOrderStatus(false)
    }
  }

  const fetchOrderConfirmationDetail = async () => {
    try {
      setDisabledInputFetch(true)
      await fetchData()
    } catch (e) {
      const error = e as AxiosError
      const responseStatus = error.response?.status
      let errorMessage = '';
      if (responseStatus === 404) {
        setOrderConfirmationDetail(null)
        errorMessage = 'Mohon pastikan nomor invoice yang Anda masukkan benar.'
      } else if (responseStatus === 403) {
        errorMessage = 'Mohon maaf, Anda tidak diizinkan untuk mengakses fitur ini.'
      } else errorMessage = 'terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi.'
      await toast(errorMessage, 'danger')
    } finally {
      setDisabledInputFetch(false)
    }
  }

  const fetchData = async () => {
    const response = await ecommerceWarehouseApi.getOrderWarehouse(invoiceNumber)
    setOrderConfirmationDetail(response.data)
  }

  return {
    invoiceNumber,
    setInvoiceNumber,
    searchOrder,
    isDisabledInputFetch,
    orderConfirmationDetail,
    toastContainer,
    isModalOpenUpdateOrderStatus,
    setModalOpenUpdateOrderStatus,
    isLoadingUpdateOrderStatus,
    setLoadingUpdateOrderStatus,
    updateOrderStatus
  }
}
